// extracted by mini-css-extract-plugin
export default {"firstSection":"Podian_firstSection__kDwYj","secondSection":"Podian_secondSection__-0w8-"};